<template lang="pug">
    div.left-bar
        div.left-bar__wrapper
            div.left-bar__logo
                router-link(:to="{name: 'home-page'}")
                    img(src='/images/client/got-me-hookd/logo.svg' alt='Logo')
            div.left-bar__items
                div.left-bar__items__item(v-for="item in menu" :class="getItemClass(item)" @click="itemClick(item, $event)")
                    router-link(v-if="item.type != 'spacer'" :to="{name: !item.click && item.route}")
                        div.left-bar__items__item__icon
                            svg-icon(:iconId='item.icon')
                            div.left-bar__items__item__icon__counter(v-if="item.counter")
                                span {{ item.counter }}


</template>

<script>
import SocialNotificationsStoreMixin from 'social/notifications/mixins/social-notifications-store-mixin'
import EventBus from '../lib/event-bus'
import Events from '../lib/events'
import ModalsList from './modals/modals-list'

export default {
    name: 'left-bar',

    mixins: [
        SocialNotificationsStoreMixin,
    ],

    data() {
        return {
            rocketChatAuthToken: null,
            rocketChatUserId: null,
            rocketChatSocket: null,
            rocketChatRoomUnreadMessages: {},
            openItem: null,
        }
    },

    computed: {
        currentRoute() {
            return this.$route.name
        },

        menu() {
            return [
                {
                    icon: 'home',
                    route: 'home-page'
                },
                {
                    icon: 'user',
                    route: 'profile-page',
                    click: this.openProfilePanel,
                },
                {
                    icon: 'bell',
                    route: 'notification-page',
                    counter: this.newNotificationsCount,
                },
                {
                    icon: 'plus',
                    route: 'post-create-edit-page'
                },
                {
                    icon: 'comment',
                    route: 'chat-page',
                    counter: this.chatUnreadMessages,
                },
                {
                    type: 'spacer',
                },
                {
                    icon: 'legal',
                    click: this.openLegalPanel,
                },
            ]
        },

        newNotificationsCount() {
            return this.notificationCounters.unread?.total
        },

        chatUnreadMessages() {
            return Object.values(this.rocketChatRoomUnreadMessages).reduce((a, b) => a + b, 0)
        },
    },

    async created() {
        if (this.$store.getters.authUser.meta.gmh_ready) {
            await this.initRocketChat()
        }
    },

    methods: {
        itemClick(item, e) {
            if (item.click) {
                const target = e.target.classList.contains('left-bar__items__item') ? e.target : e.target.closest('.left-bar__items__item')
                item.click(item, target)
            }
        },

        openProfilePanel(item, target) {
            this.openPanel(item, ModalsList.PROFILE_LEFT_PANEL, target)
        },
        openLegalPanel(item, target) {
            this.openPanel(item, ModalsList.LEGAL_LEFT_PANEL, target)
        },

        openPanel(item, panel, target) {
            this.openItem = item

            EventBus.$emit(Events.OPEN_MODAL, panel, {
                element: target,
                closeCallback: () => {
                    this.openItem = null
                },
            })
        },

        isCurrentRoute(name) {
            return this.currentRoute && this.currentRoute === name
        },

        getItemClass(item) {
            return {
                'left-bar__items__item--active': this.isCurrentRoute(item.route) || item === this.openItem,
                'left-bar__items__item--spacer': item.type == 'spacer',
            }
        },

        async initRocketChat() {
            let rocketChatUrl = window.addiesaas.rocketchat.url
            rocketChatUrl = rocketChatUrl.replace(/^http/, 'ws')

            await axios.post(`/api/customer/rocket-chat/logout`)
            const { data: { authToken, userId } } = await axios.post(`/api/customer/rocket-chat/login`)
            this.rocketChatAuthToken = authToken
            this.rocketChatUserId = userId

            this.rocketChatSocket = new WebSocket(`${rocketChatUrl}/websocket`)

            this.rocketChatSocket.onopen = this.rocketChatOnOpen
            this.rocketChatSocket.onmessage = this.rocketChatOnMessage
        },

        async rocketChatOnOpen() {
            const { data: { user } } = await axios.get(`/api/customer/rocket-chat/api/v1/users.info?userId=${this.rocketChatUserId}&fields={"userRooms":1}`)

            this.rocketChatRoomUnreadMessages = user.rooms.reduce((a, c) => {
                a[c.rid] = c.unread
                return a
            }, {});

            this.rocketChatSocket.send(JSON.stringify({
                msg: 'connect',
                version: '1',
                support: ['1', 'pre2', 'pre1'],
            }));

            this.rocketChatSocket.send(JSON.stringify({
                msg: 'method',
                id: String(Date.now() * Math.random()),
                method: 'login',
                params: [{ resume: this.rocketChatAuthToken }]
            }));

            this.rocketChatSocket.send(JSON.stringify({
                msg: 'sub',
                id: String(Date.now() * Math.random()),
                name: 'stream-notify-user',
                params: [`${this.rocketChatUserId}/subscriptions-changed`, false],
            }));
        },

        rocketChatOnMessage(e) {
            let message = JSON.parse(e.data)

            if (message.msg == 'ping') {
                this.rocketChatSocket.send(JSON.stringify({ msg: 'pong' }))
                return
            }

            if (message.msg == 'changed' && message.collection == 'stream-notify-user' && message.fields.eventName.match(/\/subscriptions-changed$/)) {
                const [action, subscription] = message.fields.args
                this.$set(this.rocketChatRoomUnreadMessages, subscription.rid, subscription.unread)
            }
        },
    },
}
</script>
